// src/App.js
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import React from "react";

// 📌 صفحات
import MenuPage from "./pages/MenuPage";
import AdminPanel from "./pages/AdminPanel";
import CartPage from "./pages/CartPage";
import SuccessPage from "./pages/SuccessPage";
import QRPage from "./pages/QRPage";
import LoginPage from "./pages/LoginPage";
import AccountingPage from "./pages/AccountingPage";
import Settings from "./pages/Settings";

// 📌 کامپوننت محافظت شده
import ProtectedRoute from "./components/ProtectedRoute";

function App() {
  return (
    <Router basename="/">
      <Routes>
        {/* 📌 Route پیش‌فرض - به /menu هدایت شود */}
        <Route path="/" element={<Navigate to="/menu" replace />} />
        
        {/* 📌 صفحات عمومی - همه می‌بینند */}
        <Route path="/login" element={<LoginPage />} />
        <Route path="/menu" element={<MenuPage />} />
        <Route path="/cart" element={<CartPage />} />
        <Route path="/success" element={<SuccessPage />} />
        <Route path="/qr" element={<QRPage />} />

        {/* 📌 صفحات خصوصی - فقط با لاگین می‌بینند */}
        <Route
          path="/admin"
          element={
            <ProtectedRoute>
              <AdminPanel />
            </ProtectedRoute>
          }
        />
        <Route
          path="/settings"
          element={
            <ProtectedRoute>
              <Settings />
            </ProtectedRoute>
          }
        />
        <Route
          path="/accounting"
          element={
            <ProtectedRoute>
              <AccountingPage />
            </ProtectedRoute>
          }
        />
        
        {/* 📌 Route برای 404 - صفحه‌ای که وجود ندارد */}
        <Route path="*" element={<Navigate to="/menu" replace />} />
      </Routes>
    </Router>
  );
}

export default App;
